// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"806c2f44","453":"2c7fc033","704":"373576e8","755":"9b77e5c5","980":"d5c2f62a"}[chunkId] + ".chunk.js";
};